module.exports = __webpack_public_path__ + "img/1746604871_OLiU.59302656.png";